@if (label) {
  <label
    class="ui-label ui-label--{{ labelSize }}"
    [ngClass]="{ 'ui-label--required': isRequired }"
    [attr.for]="inputId"
  >
    {{ label }}
  </label>
}
<div class="ui-input__container ui-input__container--with-addons">
  <div class="ui-input__addon-wrapper">
    <ng-content select=".addon-prepend"></ng-content>
  </div>

  <div class="ui-input__editor">
    <input
      #input
      [id]="inputId"
      class="ui-input__input"
      type="text"
      [value]="formattedDateValue"
      [autofocus]="autofocus"
      [placeholder]="placeholder"
      [readonly]="isDisabled"
      pattern="[0-9,\.\-\+]"
      [inputMask]="dateMask"
      (change)="onInputDate($event)"
    />

    @if (shouldDisplayErrors) {
      <pxw-icon class="ui-input__error-icon" icon="info" size="sm" />
    }
  </div>

  <div class="ui-input__addon-wrapper">
    @if (useNativePicker) {
      <input
        #inputDateNative
        class="ui-input__date-input"
        type="date"
        [value]="value"
        [min]="minInputDate"
        [max]="maxInputDate"
        (change)="onSelectedDateNativePicker($event)"
      />
    } @else {
      <input
        #inputDateNgb
        class="ui-input__date-input"
        placeholder="yyyy-mm-dd"
        [minDate]="minNgbDate"
        [maxDate]="maxNgbDate"
        (dateSelect)="onSelectedDateNgbPicker($event)"
        ngbDatepicker
        [placement]="['left-bottom', 'left-top', 'left', 'auto']"
      />
    }
    <span
      class="addon-append ui-clickable"
      [ngClass]="{ 'ui-disabled': isDisabled }"
      (click)="openDatePicker()"
    >
      <pxw-icon icon="calendar" [disabled]="isDisabled" />
    </span>
  </div>
</div>
@if (shouldDisplayErrors) {
  <div class="ui-input__error-wrapper">
    <p class="ui-input__error">{{ getErrorMessage(errorEntries[0]) }}</p>
  </div>
}

@if (helper) {
  <p class="ui-helper">
    {{ helper }}
  </p>
}

<ng-content></ng-content>
